module.exports = __webpack_public_path__ + "img/luxury-lounge-1.994331e6.jpg";